import { useState } from "react";
import { PackageOpen } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { Button } from "@/components/ui/button";
import { toast } from "@/components/ui/sonner";
import { OrderProductPicker } from "./OrderProductPicker";
import { useOrderProductLowest } from "./useOrderProducts";

/**
 * Drop-in trigger for the 订单产品资料 picker. Use it anywhere a row/form needs
 * carton data from 合同订单产品一览表.
 *
 *   <OrderProductImportButton itemNumber={row.item_number}
 *     onPick={(rec) => applyCarton(toPriceRowCarton(rec))} iconOnly />
 */
export function OrderProductImportButton({
  itemNumber = "", onPick, iconOnly = false, label,
  variant = "outline", className = "", testId = "co-import-trigger",
  allowPriceImport = false, currentPrice = null,
}) {
  const { t } = useLanguage();
  const [open, setOpen] = useState(false);
  const { lowest } = useOrderProductLowest(open ? itemNumber : "");

  return (
    <>
      <Button type="button" variant={variant} size={iconOnly ? "icon" : "sm"}
        className={iconOnly ? `h-7 w-7 ${className}` : `rounded-md ${className}`}
        title={t("co.importBtn")} onClick={() => setOpen(true)} data-testid={testId}>
        <PackageOpen size={iconOnly ? 13 : 14} className="text-brand" />
        {!iconOnly && (label || t("co.importBtn"))}
      </Button>
      <OrderProductPicker
        open={open}
        onOpenChange={setOpen}
        defaultSearch={itemNumber}
        allowPriceImport={allowPriceImport}
        currentPrice={currentPrice}
        lowestId={lowest?.id || null}
        onPick={(row, opts) => { onPick(row, opts); setOpen(false); toast.success(t("co.imported")); }}
      />
    </>
  );
}
